module.exports = __webpack_public_path__ + "img/banner-right.10fabbbc.png";